import { useBondsBondFieldApi } from '../api';

export const useBondsBondSAccId = () => {
  const response = useBondsBondFieldApi('S_ACC.ID');
  return response;
};
